import type { ESQueryModel } from '@repo/api-codegen';
import { useApiGetQueries } from '@repo/api-codegen';
import { useMemo } from 'react';
import type { ApiCatalogSort } from '../../api';
import {
	AverageRunTimeRender,
	LastExecutionRender,
	ReadOnlyQueryFrequentUsersRender,
	SQLRender,
	TotalRunsRender,
	TotalRunTimeRender,
} from '../../components/TableV2/render.tsx';
import type { ExtendedDataTableColumn } from '../../components/TableV2/types.ts';

export const useWorkspaceQueryList = (lookBackDays: number) =>
	function (props: {
		page?: number | undefined;
		filters?: { search_term?: string; sort?: ApiCatalogSort };
	}) {
		const { page, filters } = props;

		return useApiGetQueries({
			queryParams: {
				page: page || 1,
				search_term: filters?.search_term,
				page_size: 50,
				lookback_days: lookBackDays,
				sort_by: JSON.stringify(filters?.sort) || JSON.stringify({}),
			},
		});
	};

export const useColumns = (): ExtendedDataTableColumn<ESQueryModel>[] =>
	useMemo(
		() => [
			{
				accessor: 'sql',
				titleLabel: 'SQL',
				render: SQLRender,
				sortable: false,
			},
			{
				accessor: 'frequent_users',
				titleLabel: 'Users',
				render: ReadOnlyQueryFrequentUsersRender,
				sortable: false,
			},
			{
				accessor: 'average_runtime',
				titleLabel: 'Average runtime',
				render: AverageRunTimeRender,
				sortable: true,
			},
			{
				accessor: 'total_runtime',
				titleLabel: 'Total runtime',
				render: TotalRunTimeRender,
				sortable: true,
			},
			{
				accessor: 'total_runs',
				titleLabel: 'Total runs',
				render: TotalRunsRender,
				sortable: true,
			},
			{
				accessor: 'last_execution_at',
				titleLabel: 'Last execution',
				render: LastExecutionRender,
				sortable: true,
			},
		],
		[]
	);

export const useActions = () => [];
